import { Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage";
import Result from "./Result";
import DemoScreen from "./Scan/demoscreen";
import Capture from "./Scan/capture";
import ThanksPage from "./Result/thanksPage";
import ClaraViewErrorBoundary from "./ErrorBoundary";

const ClaraViewFlow = () => {
    return (
        <div className="h-full font-novatica">
            <ClaraViewErrorBoundary>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/demo" element={<DemoScreen />} />
                    <Route path="/scan" element={<Capture />} />
                    <Route path="/result" element={<Result />} />
                    <Route path="/thanks" element={<ThanksPage />} />
                </Routes>
            </ClaraViewErrorBoundary>
        </div>
    );
};

export default ClaraViewFlow;
